import React from 'react';

interface BroomIconProps {
  className?: string;
  style?: React.CSSProperties;
  /** Rendered width/height in px. */
  size?: number;
}

export const BroomIcon: React.FC<BroomIconProps> = ({ className, style, size = 20 }) => {
  return (
    <svg
      className={className}
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      data-testid="CleaningServicesIcon"
      width={size}
      height={size}
      style={style}
    >
      <path
        fill="currentColor"
        d="M16 11h-1V3c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v8H8c-2.76 0-5 2.24-5 5v7h18v-7c0-2.76-2.24-5-5-5zm3 10h-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v3h-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v3H9v-3c0-.55-.45-1-1-1s-1 .45-1 1v3H5v-5c0-1.65 1.35-3 3-3h8c1.65 0 3 1.35 3 3v5z"
      ></path>
    </svg>
  );
};
